import { prop, order } from '../constants/charts-sort';
import { getTargets } from '../constants/targets';

function getFilter() {
  return {
    prop: prop.DATE_MODIFIED,
    order: order.DESCENDING,
    headline: '',
    title: '',
    text: '',
    created: 'anytime',
    creator: '',
    modified: 'anytime',
    modifier: '',
    status: ['draft', 'published'],
    targets: getTargets().map((item) => item.value),
    source: '',
    type: '',
    allText: '',
    sections: [],
    offset: 0,
    limit: 50,
  };
}

export default getFilter;
